import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

// Fetches the org's lead-pipeline settings (stage definitions + admin-editable
// dropdown option lists) from GET /api/lead-pipeline/settings. Readable by any
// authenticated user — the ContactDetail field editors need the options.
export default function useLeadPipelineConfig() {
    const { getAuthHeader } = useAuth();
    const [config, setConfig] = useState({ stages: [] });
    const [loading, setLoading] = useState(true);

    const reload = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API}/api/lead-pipeline/settings`, { headers: getAuthHeader() });
            setConfig(res.data || { stages: [] });
        } catch {
            // keep whatever we had; consumers handle empty gracefully
        } finally {
            setLoading(false);
        }
    }, [getAuthHeader]);

    useEffect(() => { reload(); }, [reload]);

    return { config, loading, reload };
}
